import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatGdes = (n) => {
  if (n === null || n === undefined) return "";
  return new Intl.NumberFormat("fr-HT", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n) + " HTG";
};

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Une erreur est survenue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(detail);
};

export const HAITI_DEPARTMENTS = [
  "Ouest", "Nord", "Nord-Est", "Nord-Ouest", "Sud", "Sud-Est",
  "Artibonite", "Centre", "Grand'Anse", "Nippes",
];

export const productImageUrl = (image) => {
  if (!image) return "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=800&q=70";
  if (image.startsWith("http")) return image;
  return `${API}/files/${image}`;
};

export const WHATSAPP_NUMBER = "50932190716";
